import { createContext } from 'react';
import { UseBaseFlowResult } from '../shared/useBaseFlow';
import { ClaimFlowData } from '../shared/types/ClaimFlowData';
import { ClaimTypes } from '../shared/enums/ClaimTypes';
import { VoidFn } from '../shared/types/VoidFn';

export type EmailAndPhoneFlowResult = Omit<UseBaseFlowResult<ClaimFlowData>, 'open'> & {
  open: (fn: VoidFn) => void;
  claimType: ClaimTypes;
};

const EmailAndPhoneFlowContext = createContext<Partial<EmailAndPhoneFlowResult>>({});

export { EmailAndPhoneFlowContext };
